module.exports = __webpack_public_path__ + "img/e-reputation.e27f544.jpeg";